import { createSignal } from 'solid-js';

const FLOATING_LAYER_ATTR = 'data-floating-layer';

export const floatingMount = (anchor: Element | null | undefined): HTMLElement =>
  anchor?.closest<HTMLElement>('dialog') ?? document.body;

export const isInFloatingLayer = (target: EventTarget | null): boolean =>
  target instanceof Element && target.closest(`[${FLOATING_LAYER_ATTR}]`) !== null;

const [openDialogs, setOpenDialogs] = createSignal<readonly HTMLDialogElement[]>([]);

export const registerOpenDialog = (dialog: HTMLDialogElement): (() => void) => {
  setOpenDialogs((open) => [...open, dialog]);
  return () => setOpenDialogs((open) => open.filter((d) => d !== dialog));
};

export const topLayerMount = (): HTMLElement => openDialogs().at(-1) ?? document.body;
